<template>
<div class="contens">
    <div class="lefts">
       未更新个人信息的客户:<span>{{total}}</span>
        <el-table
    :data="item"
    stripe
    style="width: 100%">
    
    <el-table-column
      prop="name"
      label="姓名"
      >
    </el-table-column>
    <el-table-column
      prop="idcard"
      label="身份证号码"
      >
    </el-table-column>
    <el-table-column
      prop="telephone"
      label="电话">
    </el-table-column>
  </el-table>
    </div>
    <div class="rights">
        <div class="rr">
            更新了个人资料客户：<span>{{totals}}</span>
             <el-table
    :data="items"
    stripe
    style="width: 100%">
    
    <el-table-column
      prop="name"
      label="姓名"
      >
    </el-table-column>
    <el-table-column
      prop="idcard"
      label="身份证号码"
      >
    </el-table-column>
    <el-table-column
      prop="unionid"
      label="uid">
    </el-table-column>
  </el-table>
        </div>
        <div>
            点击过微信收款的客户：<span>{{tota}}</span>

               <el-table
    :data="ite"
    stripe
    style="width: 100%">
    
 
   
   
    <el-table-column
      prop="unionid"
      label="uid">
    </el-table-column>
  </el-table>
        </div>
    </div>
    
</div>
</template>
<script>
export default {
    name:"test",
    data(){
        return{
            ACCESS_TOKEN:"",
            item:[],
            items:[],
            ite:[],
            total:"0",
            totals:"0",
            tota:"0"
        }
    },
    methods:{
        test(){
            this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({unionid:_.exists(false)}).limit(1000).get()`,
        }).then(r=>{
          if(r.data.errcode !== 0){
            return this.$notify.error({
              title: '错误提示',
              message: '密钥过期啦，请刷新页面'
            });
          }
              r.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });
        //    console.log(r.data.data)
            this.item = r.data.data
            this.total = r.data.pager.Total
            
        })
        },
        tests(){
             this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("user2020zl").where({unionid:_.exists(true)}).limit(1000).get()`,
        }).then(rr=>{
            rr.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
            })
           
            this.totals = rr.data.pager.Total
            this.items = rr.data.data

           
        })
    
       },

       tes(){
              this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("openids").where({}).limit(1000).get()`,
        }).then(tr=>{
            tr.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
            })
            this.tota = tr.data.pager.Total
            this.ite = tr.data.data
        })
       }
    },

    created(){
        //  // get请求获取access_token
        //     this.axios
        //       .get("/api/cgi-bin/token?grant_type=client_credential", {
        //         params: {
        //           appid: "wx153c354afba9df6f",
        //           secret: "82eda09f80ff4b7b90865c533ffe47ab",
        //         },
        //       })
        //       .then((response) => {
        //         this.ACCESS_TOKEN = response.data.access_token   
        //       });
           //获取到this.ACCESS_TOKEN
     this.getTokens()

     //获取当前登录的用户数据
    this.getUserToken()
    },
    mounted(){
        setTimeout(()=>{
            this.test()
            this.tests()
            this.tes()
        },800)
        

    },
    // updated(){
    //     this.test()
    // }
}
</script>
<style scoped>
    .contens{
        width: 100%;
        display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* align-items: center; */
    }
    .lefts{
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;

    }
    .lefts span{
        font-weight: bold;
        font-size: 20px;
        color: crimson;
    }
    .rights{
         width: 58%;
          display: flex;
        flex-direction: row;
        justify-content: space-around;
        /* align-items: center;
        justify-content: center; */
    }
    .rights span{
        font-weight: bold;
        font-size: 20px;
        color: crimson;
       

    }
    .rr{
        width: 50%;
       
    }
</style>